import React from 'react'

import Select from '@peracto/peracto-editor-ui/dist/Select'

const YouTubeForm = ({ onChange, state: { url = '', aspectRatio = '16:9' } }) => {
    const aspectRatioOptions = [
        { label: '16:9', value: '16:9' },
        { label: '4:3', value: '4:3' },
        { label: '1:1', value: '1:1' },
        { label: '2:1', value: '2:1' },
    ]

    return (
        <>
            <div className="form-group">
                <label className="!mb-1">Youtube Embed Code</label>
                <textarea
                    className="form-control"
                    rows={6}
                    value={url}
                    onChange={e => onChange({ url: e.target.value })}
                />
            </div>

            <Select
                label="Aspect Ratio"
                value={aspectRatio}
                onChange={e => onChange({ aspectRatio: e.value })}
                options={aspectRatioOptions}
            />
        </>
    )
}

export default YouTubeForm
